import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'k-info-panel',
  imports: [ TranslateModule ],
  templateUrl: './info-panel.component.html',
  styleUrl: './info-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoPanelComponent {
  label = input.required<string>();
  bgColor = input.required<string>();
  descColor = input<string>();
}
